exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".save-area-overlay[data-v-1c075cc1]:last-child{margin-bottom:80px}@media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait){.save-area-overlay[data-v-1c075cc1]:last-child{margin-bottom:200px}}.sidebar-submenu[data-v-1c075cc1]{left:0;top:0;min-height:100%;-webkit-transform:translateX(-100%);-ms-transform:translateX(-100%);transform:translateX(-100%)}.subcategory-item[data-v-1c075cc1]{display:-ms-flexbox;display:flex;width:100%}.lh24[data-v-1c075cc1]{line-height:24px}\n", ""]);

// exports
